import { TableHeadersType } from "./tableHeadersType";

export const ALL_USER_APPROVED_ENRTY_LIST_HEADERS: TableHeadersType[] = [
  {
    label: "USER NAME",
    value: "name",
  },
  {
    label: "Expenses",
    value: "expense",

  },
  {
    label: "Sales",
    value: "sales",

  },
  {
    label: "Others",
    value: "other",

  },
  {
    label: "Manufacturing Journal",
    value: "manufacturing_journal_count",

  },
  {
    label: "Total Count",
    value: "total_count",

  },


];